import { getStoreIdFromHtml } from '@wsc/utils/htmlHelpers';

const STORE_ID = getStoreIdFromHtml();
import config from 'config';
import { getScriptBlobUrl } from '@wsc/utils/workerHelpers';

window.perfLayer = window.perfLayer || [];

const flattenListOfObjects = (list) => {
	return list.reduce((acc, item, index) => {
		Object.keys(item).forEach((key) => {
			acc[`event__${index}__${key}`] = item[key];
		});
		return acc;
	}, {});
};

const getMessagesFromLayer = () => {
	const toSend = [];
	while (window.perfLayer.length) {
		toSend.push(window.perfLayer.shift());
	}
	return flattenListOfObjects(toSend);
};

getScriptBlobUrl(new URL('./collectWorker.js', import.meta.url).toString())
	.then((url) => {
		const worker = new Worker(url);
		worker.name = 'collectWorker';

		const dumpEvents = () => {
			worker.postMessage(getMessagesFromLayer());
		};

		const intervalId = setInterval(dumpEvents, 5 * 1000);

		window.addEventListener('beforeunload', () => {
			dumpEvents();
			worker.terminate();
			clearInterval(intervalId);
		});
	})
	.catch((err) => {
		console.error('Error creating worker', err);
	});

export default (payload = {}) => {
	window.perfLayer.push({ ...payload, storeId: STORE_ID, env: config.ENV });
};
